const config = {
  apiBaseUrl: process.env.REACT_APP_API_URL,
  // apiBaseUrl: 'http://localhost:8083/mandi/',
  mandiLambdaApiUrl: process.env.REACT_APP_MANDI_LAMBDA_API_URL,
};

export default config;